import Grid from "@material-ui/core/Grid";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
//import TextField from '../../TextField/TextField'
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import { Checkbox } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { profileDriverAddNewEmail } from "../../../store/profile/action";
import { getProfileData } from "../../../store/profile/selector";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },

  additionalDetails: {
    textAlign: "left",
    fontSize: "20px",
    fontWeight: "bold",
  },
  txtLeft: {
    textAlign: "left",
    width: "100%",
  },
  textInput: {
    width: "100%",
    BorderBottom: "1px solid gray",
  },
  selectBox: {
    width: "100%",
    height: 50,
  },
  btnSave: {
    paddingLeft: 50,
    paddingRight: 50,
    backgroundColor: "#20419a",
    color: "white",
  },
  btnRow: {
    textAlign: "right",
    marginTop: 20,
  },
  vin1: {
    textAlign: "left",
  },
}));

const AddEmailModalForm = (props) => {
  const { handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const profileStore = useSelector(getProfileData);

  const { accountId, id } = profileStore;

  const formik = useFormik({
    initialValues: {
      accountId: profileStore?.endUserAccountEntity?.id,
      address: "",
      defaultFlag: true,
    },
    onSubmit: (values) => {
      dispatch(profileDriverAddNewEmail({ values, profileStore }));
      // alert(JSON.stringify(values, null, 2));
    },
  });

  const handleCheckbox = (e) => {
    formik.setFieldValue("defaultFlag", e.target.checked);
  };
  return (
    <>
      <form onSubmit={formik.handleSubmit} className="dae">
        <Grid container spacing={3}>
          <Grid item xs={12} >
            <InputLabel htmlFor="outlined-make" className={classes.vin1}>
              Email Address*
            </InputLabel>
            <TextField
              level="address *"
              type="email"
              name="address"
              onChange={formik.handleChange}
              value={formik.values.address}
              className={classes.textInput}
              pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\.com"
              required
            />
          </Grid>
          <Grid item xs={12}> 
            <div className="d-flex align-items-center">
              <Checkbox name="defaultFlag" checked={formik.values.defaultFlag} color="primary" onChange={handleCheckbox}/>
              <InputLabel htmlFor="outlined-make" > Set The Default Email{" "}</InputLabel>
            </div>
            </Grid>
            
            <Grid item xs={12}>
               <div className='d-flex justify-content-between align-items-center mt-3'>
            <Button onClick={handleClose}>Cancel</Button>
            <Button variant="contained" type={"submit"} color="primary" className={classes.btnSave} >Save</Button>
        </div>
            </Grid>
        </Grid>
      </form>
    </>
  );
};

export default AddEmailModalForm;
